import logo from "./logo.svg";
import "./App.css";
import FileUpload from "./FileUplaod";

function App() {
  return (
    <div className="App">
      <h4>uplaod file</h4>
      <FileUpload />
    </div>
  );
}

export default App;
